import { styled, TextField } from "@mui/material";

type StyledTextFieldProps = {
  variantProp?: string;
};
const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "variantProp",
})<StyledTextFieldProps>(({ theme, variantProp }) => ({
  // Targeting the root of the TextField
  // No specific styles applied to the root in the original code,
  // but keeping this for completeness if needed in the future.
  // '&.MuiTextField-root': {
  // },

  // Targeting the input element
  "& .MuiOutlinedInput-input": {
    backgroundColor:
      variantProp === "primary" ? theme.palette.primary.contrastText : theme.palette.primary.main,
    color:
      variantProp === "primary" ? theme.palette.grey["800"] : theme.palette.primary.contrastText,
    paddingTop: 7, // Corresponds to inputMarginDense
    paddingBottom: 7, // Corresponds to inputMarginDense
  },

  // Targeting the notched outline
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: 1,
    borderColor:
      variantProp === "primary" ? theme.palette.primary.main : theme.palette.primary.contrastText,
  },

  // Hover state for the notched outline
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor:
      variantProp === "primary" ? theme.palette.primary.dark : theme.palette.primary.contrastText,
  },

  // Focused state for the notched outline
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor:
      variantProp === "primary" ? theme.palette.primary.dark : theme.palette.primary.contrastText,
  },
}));

// eslint-disable-next-line import/no-default-export
export default function UtfTextField(props) {
  const { disabled, onChange, style, value, type = "text", InputProps = {}, variant } = props;
  return (
    <StyledTextField
      variant="outlined"
      size="small"
      disabled={disabled}
      type={type}
      inputProps={{ step: "0.1", lang: "sv" }}
      InputProps={{
        size: "small",
        style: { textAlign: "end" },
        ...InputProps,
      }}
      onChange={onChange}
      style={style}
      value={value}
      variantProp={variant}
    />
  );
}
